module.exports = __webpack_public_path__ + "img/知网.effa7485.jpg";